"use client";

import type { LinkProps } from "./Link";

import { formatPhoneForTel } from "@homeinstead/shared";
import { useEffect } from "react";
import { Link } from "./Link";

export type PhoneLinkProps = Omit<LinkProps, "href"> & {
  phoneNumber: string;
  tabIndex?: number;
};

const PhoneLink = ({
  className,
  variant = "primary",
  children,
  phoneNumber,
  onClick,
  ...props
}: PhoneLinkProps) => {
  useEffect(() => {
    // This is a bit of a hack to ensure we run Invoca to replace phone numbers whenever we display a phone
    // number, even after initial page load
    window.Invoca?.PNAPI?.run();
  }, []);

  return (
    <Link
      className={className}
      href={`tel:${formatPhoneForTel(phoneNumber)}`}
      onClick={onClick}
      variant={variant}
      {...props}
    >
      {children ? children : phoneNumber}
    </Link>
  );
};

export default PhoneLink;
